
const PrivacyPage = () => {
    return (
        <div style={{marginTop: "90px", display: "flex", flexDirection: "column", textAlign: "center"}} className="container">
            <h3 style={{margin: "auto", padding: "20px 0"}}>
                Яку інформацію про вас ми збираємо
            </h3>
            <div style={{marginBottom: "10px"}}>
                Типи даних, які ми збираємо та обробляємо, включають наступне: -Ваш SteamID
                Додаткові дані можуть бути зібрані, якщо ви вирішите поділитися ними, наприклад, якщо ви заповните додаткові поля у своєму профілі.
            </div>
            <div style={{marginBottom: "10px"}}>
                Ми збираємо деяку або всю цю інформацію в таких випадках:
                - Ви авторизуєтеся як учасник на цьому сайті.
                - Ви використовуєте нашу форму зворотного зв’язку.
                - Ви переглядаєте цей сайт. Дивіться пункт "Політика щодо файлів cookie" нижче.
            </div>
            <h3 style={{margin: "auto", padding: "20px 0"}}>
                Як використовується ваша особиста інформація
            </h3>
            <div style={{marginBottom: "10px"}}>
                Ми можемо використовувати вашу особисту інформацію в наступних цілях:
                - Для того, щоб зробити вас зареєстрованим учасником нашого сайту, щоб ми могли надавати послуги
                - Інші варіанти використання вашої особистої інформації
            </div>
            <div style={{marginBottom: "10px"}}>
                Під час вашого використання нашого сайту ми можемо збирати інформацію, не пов’язану з особистими даними про вас. Ці дані можуть містити технічну інформацію про браузер або тип пристрою, який ви використовуєте. Ця інформація буде використовуватися виключно для цілей аналітики та відстеження кількості відвідувачів нашого сайту.
            </div>
            <h3 style={{margin: "auto", padding: "20px 0"}}>
                Забезпечення безпеки даних
            </h3>
            <div style={{marginBottom: "10px"}}>
                Ми прагнемо забезпечити безпеку будь-якої інформації, яку ви нам надаєте. Щоб запобігти несанкціонованому доступу або розголошенню інформації, ми додали відповідні заходи та процедури для захисту і забезпечення безпеки інформації, яку ми збираємо.
            </div>
            <h3 style={{margin: "auto", padding: "20px 0"}}>
                Політика щодо файлів cookie
            </h3>
            <div style={{marginBottom: "10px"}}>
                Cookie - це невеликі текстові файли, які будуть встановлені нашим сайтом на ваш комп’ютер, вони дозволять нам надавати певні функції на нашому сайті, такі як можливість входу в систему або запам’ятовування певних уподобань.
            </div>
            <h3 style={{margin: "auto", padding: "20px 0"}}>
                Права
            </h3>
            <div style={{marginBottom: "10px"}}>
                Ви маєте право отримати доступ до особистих даних, які у нас є про вас, або отримати їх копію. Для цього зв’яжіться з нами. Якщо ви вважаєте, що інформація, яку ми маємо про вас, є неповною або неточною, ви можете попросити нас доповнити або виправити цю інформацію.
            </div>
            <div style={{marginBottom: "10px"}}>
                Ви також маєте право запитати видалення ваших особистих даних. Будь ласка, зв’яжіться з нами, якщо ви хочете, щоб ми видалили ваші особисті дані.
            </div>
            <h3 style={{margin: "auto", padding: "20px 0"}}>
                Прийняття політики
            </h3>
            <div style={{marginBottom: "10px"}}>
                Подальше використання нашого сайту означає вашу повну згоду з цією політикою. Якщо ви не згодні з нашою політикою, будь ласка, не використовуйте цей сайт. Під час реєстрації ми також запросимо вашу явну згоду з політикою конфіденційності.
            </div>
            <h3 style={{margin: "auto", padding: "20px 0"}}>
                Зміни до політики
            </h3>
            <div style={{margin: "10px 0 40px"}}>
                Ми можемо вносити зміни до цієї політики в будь-який час. Вам може бути запропоновано ознайомитися і повторно прийняти інформацію в цій політиці, якщо вона зміниться в майбутньому.
            </div>
        </div>
    );
};

export default PrivacyPage;